export class Competition {
    Id: number;
    Name: string;
    Description: string;
    StartDateUtc: Date;
    EndDateUtc: Date;
    DateCreatedUtc: Date;
    CreatedByUserId: string;
    Enabled: boolean;
    Entries: CompetitionEntry[];
    CustomFields: CustomFields[];
    CompetitionCustomFieldOptions: CompetitionCustomFieldOptions[];
    ImageId: string;
    constructor(item: CompetitionResponse = null) {
        if (item !== null) {
            this.Name = item.Name;
            this.Description = item.Description;
            this.StartDateUtc = item && new Date(item.StartDateUtc + 'z');;
            this.EndDateUtc = item && item.EndDateUtc ;
            this.DateCreatedUtc = new Date(item.DateCreatedUtc);
            this.CreatedByUserId = item.CreatedByUserId;
            this.Enabled = item.Enabled;
            this.Entries = item.Entries;
            this.CustomFields = item.CustomFields;
            this.ImageId = item.ImageId;
            this.CompetitionCustomFieldOptions  = item.CompetitionCustomFieldOptions
        }
    }
}

export interface CompetitionResponse {
    Name: string;
    Description: string;
    StartDateUtc: Date;
    EndDateUtc: Date;
    DateCreatedUtc: string;
    CreatedByUserId: string;
    Enabled: boolean;
    Entries: CompetitionEntry[];
    CustomFields: CustomFields[];
    ImageId: string;
    CompetitionCustomFieldOptions: CompetitionCustomFieldOptions[];
}


export class CreateCompetition {
   Id: number;
   Name: string;
   Description: string;
   StartDateUtc: Date;
   EndDateUtc: Date;
   Enabled: boolean;
   CustomFields: CustomFields[];
   ImageId: string;
}

export interface CustomFields{
    FieldName: '',
    FieldType: number,
    IsRequired: false,
    CompetitionCustomFieldOptions: CompetitionCustomFieldOptions[]
}

export interface CompetitionEntry {
    Id: number;
    CompetitionId: number;
    Description: string;
    DateCreatedUtc: Date;
    FileId: string;
    UserName: string;
    Email: string;
    Cell: string;
    Profile: string;
    IdNumber: string;
    FirstName: string;
    LastName: string;
    ContactNumber: string;
    Consent: boolean;
}

export class EditCompetition extends CreateCompetition {
    constructor(item?: Competition) {
        super();
        this.Id = item.Id;
        this.Name = item.Name;
        this.Description = item.Description;
        this.StartDateUtc = new Date(item.StartDateUtc) ;
        this.EndDateUtc = new Date(item.EndDateUtc);
        this.Enabled = item.Enabled ? true : false;
        this.CustomFields = item.CustomFields;
        this.ImageId = item.ImageId;
    }
}

export interface CompetitionCustomFieldOptions {
    CustomFieldId: number;
    OptionText: string;
}


// WEBPACK FOOTER //
// ./src/app/models/inModels/Competition.ts